// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Caml_array from "../../../../../../../../../node_modules/rescript/lib/es6/caml_array.js";
import * as Belt_Option from "../../../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Api from "@react-google-maps/api";

function getGoogleConfig(config) {
  var anchorPoints = config.anchor;
  return {
          position: config.position,
          options: anchorPoints !== undefined ? ({
                pixelOffset: {
                  width: Caml_array.get(anchorPoints, 0),
                  height: Caml_array.get(anchorPoints, 1)
                }
              }) : undefined,
          ref: config.ref,
          onCloseClick: config.onCloseClick
        };
}

function PopupComponentMod(Props) {
  var lib_nameOpt = Props.lib_name;
  var config = Props.config;
  var children = Props.children;
  var lib_name = lib_nameOpt !== undefined ? lib_nameOpt : /* GoogleMap */0;
  if (lib_name) {
    return null;
  }
  var googleConfig = getGoogleConfig(config);
  return React.createElement(Api.InfoWindow, {
              position: googleConfig.position,
              options: googleConfig.options,
              onCloseClick: Belt_Option.getWithDefault(googleConfig.onCloseClick, (function (param) {
                      
                    })),
              children: children
            });
}

var make = PopupComponentMod;

export {
  getGoogleConfig ,
  make ,
  
}
/* react Not a pure module */
